// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS */
.flatpickr-calendar .flatpickr-day.selected {
    background-color: transparent;
}

`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/shedule.css"],"names":[],"mappings":"AAAA,QAAQ;AACR;IACI,6BAA6B;AACjC","sourcesContent":["/* CSS */\n.flatpickr-calendar .flatpickr-day.selected {\n    background-color: transparent;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
